import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
} from "date-fns";

// Short relative timestamp for lounge cards (workorder step 3: date-fns,
// Kurzformat 12m/2h/2d). Falls back to "now" under a minute; anything a day
// or older counts whole days ("2d", "14d") — the feed is capped at recent
// craft talk, so no month/year tier is drawn in the design.
export const shortRelativeTime = (iso, now = new Date()) => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  if (differenceInSeconds(now, date) < 60) return "now";
  const minutes = differenceInMinutes(now, date);
  if (minutes < 60) return `${minutes}m`;
  const hours = differenceInHours(now, date);
  if (hours < 24) return `${hours}h`;
  return `${differenceInDays(now, date)}d`;
};

export default shortRelativeTime;
